import React, { useMemo } from 'react';

const LINES = {
  clear_warm: ["Sunny day — race you outside! 🏃‍♀️", "☀️ I can feel my whiskers sparkling!", "Perfect lounging weather ✨"],
  clear_cold: ["Bright but brisk ❄️ grab a scarf!", "Crisp and sunny — my fav!", "Clear skies, cold noses 🥶"],
  partly_cloudy: ["Mix of sun and clouds today ⛅", "A good day for focus mode!", "Breezy vibes 🍃"],
  cloudy: ["Cozy cloud day ☁️", "A mug of cocoa would be nice ☕", "Chill grey vibes — let's journal!"],
  rain: ["Brr, splashy day 🌧️ stay dry!", "Pitter-patter playlist time 🎶", "Rainy days = reading days 📖"],
  thunder: ["Whoa, thunder! ⚡ Blanket fort time!", "I'll be hiding under the bed 🙈", "Stay safe, friend!"],
  snow: ["SNOW DAY! ❄️❄️ Let's go sledding!", "My paws love the fluff 🐾", "Winter wonderland vibes!"],
  sleet: ["Icy mix out there — step carefully! 🌨️"],
  fog: ["Spooky foggy morning 🌫️", "Can't see my tail in this!"],
};

function pickLine(condition, temp) {
  let bucket = condition || 'cloudy';
  if (condition === 'clear') {
    bucket = temp >= 15 ? 'clear_warm' : 'clear_cold';
  }
  const arr = LINES[bucket] || LINES.cloudy;
  // Pick based on a simple hash of today's date + condition for stability
  const today = new Date().toISOString().slice(0, 10);
  let h = 0;
  for (const c of today + bucket) h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return arr[h % arr.length];
}

export default function PetDialog({ weather }) {
  const line = useMemo(() => {
    if (!weather || !weather.condition) return null;
    return pickLine(weather.condition, weather.temp_c ?? 10);
  }, [weather]);

  if (!line) return null;

  return (
    <div
      className="relative mx-auto mb-2 max-w-[260px] rounded-2xl border-2 border-black bg-white dark:bg-[#2d2d54] px-3 py-2 text-center text-xs font-semibold shadow-[3px_3px_0px_0px_rgba(0,0,0,1)] animate-bounce-in"
      data-testid="pet-dialog"
    >
      {line}
      {/* Tail */}
      <span
        className="absolute left-1/2 -translate-x-1/2 -bottom-2 w-0 h-0"
        style={{
          borderLeft: '8px solid transparent',
          borderRight: '8px solid transparent',
          borderTop: '10px solid #000',
        }}
      />
      <span
        className="absolute left-1/2 -translate-x-1/2 -bottom-[5px] w-0 h-0"
        style={{
          borderLeft: '6px solid transparent',
          borderRight: '6px solid transparent',
          borderTop: '8px solid #fff',
        }}
      />
    </div>
  );
}
